import numeral from 'numeral';
import converter from 'number-to-words';
import { capitalCase } from 'change-case';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return `₱ ${numeral(number).format(Number.isInteger(number) ? '0,0.00' : '0,0.00')}`;
}

export function fCurrencyNoPrefix(number) {
  return `${numeral(number).format(Number.isInteger(number) ? '0,0.00' : '0,0.00')}`;
}

export function fCurrencyInWords(amount) {
  if (amount == null || !Number.isFinite(Number(amount))) {
    return '';
  }

  const [pesoValue, centValue] = fCurrencyNoPrefix(amount).replace(/,/g, '').split('.');
  const pesos = parseInt(pesoValue, 10);
  const cents = parseInt(centValue, 10);
  const pesoUnit = pesos === 1 ? 'peso' : 'pesos';
  const centUnit = cents === 1 ? 'cent' : 'cents';
  const pesoWords = `${converter.toWords(pesos)} ${pesoUnit}`;
  const centWords = cents > 0 ? ` and ${converter.toWords(cents)} ${centUnit}` : '';

  return capitalCase(`${pesoWords}${centWords}`);
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fDecimal(number) {
  return numeral(number * 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}
